import React, { useEffect, useState } from 'react';
import styled from 'styled-components'
import ActuDashBoard from '../Page/AdminPage/ActuDashBoard'
import AddPostDashBoard from '../Page/AdminPage/AddPostDashBoard'
import EmailDashBoard from '../Page/AdminPage/EmailDashBoard'
import {Link} from 'react-router-dom'
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ArticleIcon from '@mui/icons-material/Article';
import AddTaskIcon from '@mui/icons-material/AddTask';
import LiquorIcon from '@mui/icons-material/Liquor';
import Cocktail from '../Page/AdminPage/Cocktail'

const DashBoard = () => {

    const [optionMenu,setOptionMenu] = useState(['Actualité', 'Ajouter Post','Cocktail', 'Envoi Email']);
    const[currentMenu, setCurrentMenu] = useState('');
    const [optionChoiced, setOptionChoiced] = useState('')



    const handleChoice = (e) => {
        setCurrentMenu(e.target.textContent)
       
        }


    

        
    const switchChoice = () => {switch(currentMenu){                
            case 'Actualité':
                return  <ActuDashBoard/>                
            case 'Ajouter Post':
                return  <AddPostDashBoard/>       
            case 'Cocktail':
                return  <Cocktail/>           
            case 'Envoi Email':
                return  <EmailDashBoard/>                           
            default: return <h2>No option selected</h2>
        }
    }

    useEffect(()=> {
        setOptionChoiced(switchChoice)
    },[currentMenu])
  

    return (
        
        <Container>
            <Menu>
                <Link to="/admin" className='logoadmin'>
                  <span className='admin'>Admin</span>
                </Link>
                      {optionMenu.map((option,key) => {
                           return ( <p key={key} className='nameOption' onClick={handleChoice}>{option}</p> )
                       })}
                       
                    
                <Link to='/' ><button >Exit</button></Link>


            </Menu>
            <SideBar>
                       
                        <ArticleIcon className='iconarticle'/>
                        <p  className='nameOption' onClick={handleChoice}>Actualité</p>
                        <AddTaskIcon className='addposticon'/>
                        <p  className='nameOption' onClick={handleChoice}>Ajouter Post</p>
                       <MailOutlineIcon className='emailicon'/>
                        <p  className='nameOption' onClick={handleChoice}>Envoi Email</p>
                         <LiquorIcon className='liquoricon'/>
                        <p  className='nameOption' onClick={handleChoice}>Cocktail</p>
            </SideBar>
            <Content>
                
                <Section>
                   {optionChoiced}

                </Section>
            </Content>
        </Container>
    );
};


const SideBar = styled.div`
display:flex;
width: 80vw;


justify-content:flex-end;
align-items: flex-start;
position:absolute;
top:0px;
left:50%;
transform: translateX(-50%);

.addposticon{
    position:relative;
    top: 20px;
    left:50px;
    font-size: 22px;
    color: #242D6B;
    
}
.iconarticle{
     position:relative;
    top: 20px;
    left:50px;
    font-size: 22px;
    color: #242D6B;

}
.emailicon{
     position:relative;
    top: 20px;
    left:50px;
    font-size: 22px;
    color: #242D6B;

}

.liquoricon{
     position:relative;
    top: 20px;
    left:50px;
    font-size: 22px;
    color: #242D6B;

}

p{
    padding: 10px 20px;
    font-size: 16px;
    width: 20px;
    
    overflow: hidden;
    cursor: pointer;
    color:transparent;
    height:30px;
    z-index:11;
    position:relative;
    top: 20px;
    left:12px;
    
}

@media (min-width:768px){
    display:none;
}

`
const Container = styled.div`
height: 100vh;
width: 100vw;
overflow:hidden;
background-color: #F8F8F8;
.logoadmin{
    text-decoration: none;
}
`

const Menu = styled.nav`

.nameOption{
    display:none;
}

.admin{
    font-size: 35px;
    font-weight: 700;
    font-family: 'Poppins';
    color:#242D6B
    ;
}

width: 100%;
height: 60px;
font-family:'Lato';
font-weight: 600;
background-color: #eeedfd;

display:flex;
justify-content: space-between;
align-items:center;
box-shadow: #EEEDFD 0px  26px 30px 10px,
#EEEDFD 0px  16px 10px -10px;
button{display:none}


@media(min-width: 768px) {

    button{

    
    padding:3px 10px;
    border-radius: 5px;
    border: none;
    margin-right: 12px;
    font-family:'Poppins';
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    color: #f9f9f9;
    background-color: #242D6B;
    
}







.nameOption{
    display: flex;
    font-family: 'Lato';
    font-weight: 600;
    font-size: 18px;
    cursor:pointer;
    color: #242D6B;
    
    box-shadow: rgb ( 0 0 0 /73%)  26px 30px 10px,
    rgb(0 0 0 / 69%) 0px  16px 10px -10px;
    
    border-radius: 4px;
    padding: 5px 20px;

    background-color: #eeedfd;

    &:hover{
        background-color:
    }
}


}

`

const Content = styled.div`
display:flex;
justify-content: center;
align-items:center;
height: 100%;
width: 100%
`


const Section = styled.div`
flex:3;

height: 100%;

`

export default DashBoard;